import { LoginForm } from '../../features/LoginForm/ui/LoginForm/LoginForm';
import { PageWrapper } from '../../shared/ui/PageWrapper/PageWrapper';


export function LoginPage() {
    return (
        <PageWrapper
            title='Вход в систему'
            subText='Авторизуйтесь, чтобы войти в систему'
        >
            <LoginForm />
        </PageWrapper>
    )
}